const PAGE_ACCOUNT = 'PAGE_ACCOUNT';
const PAGE_ARTICLE_DETAIL = 'PAGE_ARTICLE_DETAIL';
const PAGE_HOME = 'PAGE_HOME';
export const PAGE_LIVE = 'PAGE_LIVE';
const PAGE_MOVIE_DETAIL = 'PAGE_MOVIE_DETAIL';
const PAGE_MOVIES = 'PAGE_MOVIES';
const PAGE_NETWORK_DETAIL = 'PAGE_NETWORK_DETAIL';
export const PAGE_NETWORK_UPSELL = 'PAGE_NETWORK_UPSELL';
const PAGE_RESET_PASSWORD = 'PAGE_RESET_PASSWORD';
const PAGE_SEARCH = 'PAGE_SEARCH';
const PAGE_SERIES_DETAIL = 'PAGE_SERIES_DETAIL';
const PAGE_SHOWS = 'PAGE_SHOWS';
const PAGE_SIGNIN = 'PAGE_SIGNIN';
export const PAGE_WATCH = 'PAGE_WATCH';
export const PAGE_COLLECTION = 'PAGE_COLLECTION';
const PAGE_CHANNEL = 'PAGE_CHANNEL';

const ALL_PAGES = [
  PAGE_ACCOUNT,
  PAGE_ARTICLE_DETAIL,
  PAGE_HOME,
  PAGE_LIVE,
  PAGE_MOVIE_DETAIL,
  PAGE_MOVIES,
  PAGE_NETWORK_DETAIL,
  PAGE_NETWORK_UPSELL,
  PAGE_RESET_PASSWORD,
  PAGE_SEARCH,
  PAGE_SERIES_DETAIL,
  PAGE_SHOWS,
  PAGE_SIGNIN,
  PAGE_WATCH,
  PAGE_CHANNEL,
];

export const isValidPage = page => ALL_PAGES.indexOf(page) !== -1;
